if (!customElements.get('subscription-block')) {
  customElements.define(
    'subscription-block',
    class Sudscription extends HTMLElement {
      constructor() {
        super();
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.options = this.querySelectorAll('[data-option]');
        if (this.options.length === 0) return;
        this.optionButtons = this.querySelectorAll('[data-toggle]');
        this.optionContent = this.querySelectorAll('[data-body]');
        this.variants = this.querySelectorAll('[data-variant-id]');
        this.sellingPlans = this.querySelectorAll('[data-plan-id]');
        this.addToCartButton = this.querySelector('[data-atc]');
        this.priceContainer = this.querySelector('[data-price-container]');
      }

      get variantID() {
        return this.dataset.selectedVariant;
      }

      get sellingPlanID() {
        return this.dataset.sellingPlan;
      }

      connectedCallback() {
        this.toggleAccordions();
        this.selectVariantsHandler();
        this.selectSellingPlanHandler();
        if (!this.addToCartButton) return;
        this.addToCartButton.addEventListener('click', () => this.addToCart());
        this.setInitialHeight();
      }

      toggleAccordions() {
        if (this.optionButtons.length === 0) return;
        this.optionButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.hideAllOptions();
            this.showOption(button);
          });
        });
      }

      selectVariantsHandler() {
        if (this.variants.length === 0) return;
        this.variants.forEach((variant) => {
          variant.addEventListener('click', () => {
            let variant_data = null;
            const variantId = variant.dataset.variantId;
            this.dataset.selectedVariant = variantId;
            if (variant.dataset.options) {
              variant_data = JSON.parse(window.atob(variant.dataset.options));
            }
            variant.hasAttribute('data-one-time-purchase') ? this.updateUrl('variant', variantId, 'single') : this.updateUrl('variant', variantId, 'subscription', variant_data);
            this.replaceHTML();
          });
        });
      }

      selectSellingPlanHandler() {
        if (this.sellingPlans.length === 0) return;
        this.sellingPlans.forEach((variant) => {
          variant.addEventListener('click', () => {
            const planId = variant.dataset.planId;
            this.dataset.sellingPlan = planId;
            this.updateUrl('selling_plan', planId, 'subscription');
            this.replaceHTML();
          });
        });
      }

      async replaceHTML() {
        const url = window.location.href;
        const response = await fetch(url);
        if (!response.ok) return;
        const result = await response.text();
        const oldContainer = document.querySelector('product-info');
        const HTML = new DOMParser().parseFromString(result, 'text/html');
        const newContainer = HTML.querySelector('product-info');
        if (oldContainer && newContainer) {
          oldContainer.outerHTML = newContainer.outerHTML;
        }

        this.updateMedia();
      }

      async addToCart() {
        const url = `${window.Shopify.routes.root}cart/add.js`;
        this.addToCartButton.setAttribute('aria-disabled', true);
        this.addToCartButton.classList.add('loading');
        this.addToCartButton.querySelector('.loading__spinner').classList.remove('hidden');

        const data = {
          items: [
            {
              id: this.variantID,
              quantity: 1,
            },
          ],
          sections: this.cart
            .getSectionsToRender()
            .map((section) => section.id)
            .join(','),
          sections_url: window.location.pathname,
        };

        if (this.sellingPlanID !== 'null') {
          data.items[0].selling_plan = this.sellingPlanID;
        }

        const config = {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        };

        const response = await fetch(url, config);
        const result = await response.json();

        if (!response.ok) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: this.variantID,
            errors: response.errors || response.description,
            message: response.message,
          });
        } else {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: this.variantID,
            cartData: result,
          });
          this.addToCartButton.removeAttribute('aria-disabled');
          this.addToCartButton.classList.remove('loading');
          this.addToCartButton.querySelector('.loading__spinner').classList.add('hidden');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.cart.renderContents(result);
        }
      }

      hideAllOptions() {
        this.options.forEach((item) => item.removeAttribute('open'));
        this.optionContent.forEach((item) => (item.style.height = '0px'));
      }

      showOption(option) {
        const currentOption = option.dataset.toggle;

        const optionBody = this.querySelector(`[data-body="${currentOption}"]`);
        if (!optionBody) return;
        const optionParrent = option.closest('[data-option]');
        optionParrent.setAttribute('open', true);
        const height = optionBody.scrollHeight;
        optionBody.style.height = `${height}px`;
        const activeOption = this.querySelector(`${currentOption === 'single' ? '[data-one-time-purchase].active' : '[data-subscription-purchase].active'}`);
        if (!activeOption) return;
        activeOption.click();
      }

      updateUrl(type, value, option, variant_data) {
        let url = '';
        const baseUrl = window.location.pathname;
        const pageParams = new URLSearchParams(window.location.search);
        switch (option) {
          case 'subscription':
            if (window.location.href.includes('selling_plan') && window.location.href.includes('variant')) {
              const variantId = decodeURIComponent(pageParams.get('variant'));
              url = type === 'variant' ? this.prepareVariantOption(baseUrl, variant_data) : `${baseUrl}?variant=${variantId}&selling_plan=${value}`;
            } else if (window.location.href.includes('selling_plan') && !window.location.href.includes('variant')) {
              url = type === 'variant' ? this.prepareVariantOption(baseUrl, variant_data) : `${baseUrl}?variant=${this.variantID}&selling_plan=${value}`;
            } else if (!window.location.href.includes('selling_plan') && window.location.href.includes('variant')) {
              const variantId = decodeURIComponent(pageParams.get('variant'));
              url = type === 'variant' ? `${baseUrl}?variant=${value}&selling_plan=${this.sellingPlanID}` : `${baseUrl}?variant=${variantId}&selling_plan=${value}`;
            } else {
              url = type === 'variant' ? `${baseUrl}?variant=${value}&selling_plan=${this.sellingPlanID}` : `${baseUrl}?variant=${this.variantID}&selling_plan=${value}`;
            }
            break;
          case 'single':
            url = `${baseUrl}?variant=${value}&one_time_purchase=true`;
            break;
        }

        window.history.replaceState({}, '', url);
      }

      prepareVariantOption(baseUrl, data) {
        const activeSubsctiptionType = this.querySelector('[data-plan-id].active');
        const activeOption = data.options.find((option) => option.name === activeSubsctiptionType.dataset.name);
        return `${baseUrl}?variant=${data.id}&selling_plan=${activeOption.selling_plan_id}`;
      }

      updateMedia() {
        const productInfo = this.closest('product-info');
        if (productInfo && productInfo.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
      }

      setInitialHeight() {
        if (this.optionContent.length === 0) return;
        this.optionContent.forEach((option) => {
          const initialHeight = option.clientHeight;
          option.style.height = `${initialHeight}px`;
        });
      }
    }
  );
}
